export var LABEL_SIZES = {
  NORMAL: "normal",
  LARGE: "large"
};
export var LABEL_ELEMENTS = {
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6"
};